const METER_DAY_URL_KEY = 'meter_day';

export { METER_DAY_URL_KEY };
